import Header from "../Header/Header";
import Snack from "../Snack/Snack";
import { Helmet } from "react-helmet";
import "./Home.css";

const Home = () => {
  return (
    <>
      <Helmet>
        <title>1goodthing</title>
      </Helmet>
      <div className="App">
        <Header />
        <h2>🥛 🍪 A Snack Driven Development</h2>
        <Snack
          commitTitle="Not a journal"
          commitDescription="Just one good thing. Every day. A win, a moment worth remembering, a laugh, a cry — whatever stood out. No lengthy entries. Just one thing, one day at a time."
          snack="🥜🍨🍒"
          snackDescription="Peanut Butter Sunday"
          locationTitle="Bruster's"
          locationURL="https://brusters.com/locations/roswell/58/"
          snackNumber={4}
          commitLink="https://apps.apple.com/app/1goodthing"
        />
      </div>
    </>
  );
};

export default Home;
